module.exports = __webpack_public_path__ + "static/media/gatsby.3d7b6e73.svg";